export var ROVO_PARAM_PREFIX = 'rovoChat';
export var ROVO_VALID_PARAMS = ['pathway', 'agentId', 'conversationId', 'prompt', 'cloudId', 'triggerOpen'];